/** This specifies how much the KBA lasts. */
export const KBA_DURATION_SECONDS = 120; // 2 minutes

export const KBA_MAX_RETRIES = 2;

export const STRIPE_MAX_RETRIES = 2;